import { Button, Card, CardBody, CardHeader, Spinner } from "@heroui/react";
import { useNavigate, useParams } from "react-router-dom";
import { usePostData, useFetchData } from "@/hooks";
import { showToast } from "@/utils";
import { MaterialCategoryForm } from "@/components/forms";
import { ErrorState, ThemedText, PageHeader } from "@/components/ui";
import { LuArrowLeft } from "react-icons/lu";

const ProductCategoryCreate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const isEdit = !!id;

    // Fetch data if editing
    const fetchUrl = isEdit ? `material-categories/${id}/edit` : null;
    const {
        data: initialData,
        isLoading: isFetching,
        error: fetchError,
        refetch,
    } = useFetchData(fetchUrl);

    // Mutation
    const endpoint = isEdit
        ? `material-categories/${id}/update`
        : "material-categories/store";
    const updateCategory = usePostData(endpoint);

    const onSubmit = (data) => {
        updateCategory.mutate(data, {
            method: isEdit ? "put" : "post",
            onSuccess: () => {
                showToast(
                    "success",
                    "Berhasil",
                    `Kategori produk berhasil ${isEdit ? "diperbarui" : "ditambahkan"}.`,
                );
                navigate("/products-category");
            },
            onError: (err) => {
                let message =
                    "Terjadi kesalahan pada sistem. Silakan coba beberapa saat lagi atau hubungi administrator.";

                if (err.response?.status === 422) {
                    message =
                        "Mohon periksa kembali input Anda. Pastikan semua kolom terisi dengan benar.";
                }

                showToast("error", "Gagal", message);
            },
        });
    };

    if (isEdit && fetchError) {
        return (
            <ErrorState
                title="Gagal Memuat Data"
                description="Terjadi kesalahan saat memuat data. Silakan coba lagi atau hubungi administrator."
                onAction={refetch}
            />
        );
    }

    return (
        <div className="mx-auto flex max-w-3xl flex-col gap-8">
            <div className="flex gap-4">
                <Button isIconOnly variant="light" onPress={() => navigate(-1)}>
                    <LuArrowLeft size={20} />
                </Button>
                <PageHeader
                    title={
                        isEdit
                            ? "Edit Kategori Produk"
                            : "Tambah Kategori Produk"
                    }
                    breadcrumbs={[
                        { label: "Dashboard", href: "/" },
                        { label: "Produk", href: "/products" },
                        { label: "Kategori", href: "/products-category" },
                        { label: isEdit ? "Edit" : "Tambah" },
                    ]}
                />
            </div>
            <Card className="border-default-200 w-full border" shadow="none">
                <CardHeader className="bg-default-100/70 px-6 py-4">
                    <ThemedText className="font-semibold">
                        Informasi Kategori Produk
                    </ThemedText>
                </CardHeader>
                <CardBody className="p-6">
                    {isEdit && isFetching ? (
                        <div className="flex h-48 w-full items-center justify-center">
                            <Spinner label="Memuat data..." color="primary" />
                        </div>
                    ) : (
                        <MaterialCategoryForm
                            initialData={initialData}
                            onSubmit={onSubmit}
                            isLoading={updateCategory.isLoading}
                            onCancel={() => navigate("/products-category")}
                        />
                    )}
                </CardBody>
            </Card>
        </div>
    );
};

export default ProductCategoryCreate;
